/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAccountInactivityPathParams,
	WhatsAppAccountInactivityResponse,
} from '../types/WhatsAppAccountInactivity'

/**
 * GET /organisations/:organisationId/whatsapp-account/inactivity
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::inactivity
 */
export async function whatsAppAccountInactivity(
	organisationId: WhatsAppAccountInactivityPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAccountInactivityResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-account/inactivity`, config)
}
